import React from "react";
import "./pay-bill.less";
import { withRouter } from 'react-router'
import { setHeader } from "@/util/set-header";
import { wechatPayApi, alipayApi, billResultApi, billDetailApi } from "@/api/sany";
import { List, Radio, Button, Toast, Modal } from "antd-mobile";
import { getUrlQueryDic, phonePlatform } from "@/util/util";
const Item = List.Item
const alert = Modal.alert
@(withRouter as any)
export default class PayBill extends React.Component<any, any> {
  // 返回的订单ID
  billId = ''
  isBack = false
  constructor(prop: any) {
    super(prop)
    this.state = {
      payCode: '',
      money: '',
      subject_name: '',
      number: ''
    }
    if (this.props.location.state) {
      // alert('tips',this.props.location.state.id)
      this.billId = this.props.location.state.id
    }
    this.confirmPay = this.confirmPay.bind(this)
    const queryDic = getUrlQueryDic(window.location.href)
    console.log('queryDic',queryDic)
    // 支付回调传来的参数
    if (queryDic.billId) {
      this.isBack = true
      this.billId = queryDic.billId
      this.showPayResult()
    }
    this.fetchBillDetail()
    this.leftClick = this.leftClick.bind(this)
    this.goHomePage = this.goHomePage.bind(this)
  }

  componentDidMount() {
    setHeader({title: '支付账单', leftToHome: this.goHomePage, leftClick: this.leftClick})
  }

  leftClick() {
    //返回App
    const { history } = this.props
    if (history.length > 1) {
      if (this.isBack) {
        if (phonePlatform() === 'iOS') {
          history.go(-1)
        } else {
          history.go(-2)
        }
      } else {
        history.goBack()
      }
    } else {
      window.location.href = "uhomeoc://thirdparty.goBack?params={type:native}"
    }
  }

  goHomePage() {
    this.props.history.replace('/sany/dorm-list')
  }

  showPayResult() {
    alert('', <div>请确认支付是否完成?</div>, [
      { text: '重新支付', onPress: () => console.log('支付遇到问题') },
      { text: '支付完成', onPress: () => this.fetchPayResult() },
    ])
  }

  async fetchBillDetail() {
    const billId = this.billId
    Toast.loading('加载中...')
    const {data} = await billDetailApi({billId})
    Toast.hide()
    if (data.code === 'SUCCESS') {
      if (data.data && data.data.BillData) {
        this.setState({
          money: data.data.BillData.money,
          subject_name: data.data.BillData.subject_name,
          number: data.data.BillData.number
        })
      }
    } else {
      Toast.info(data.msg)
    }
  }

  async fetchAliPayInfo() {
    const billId = this.billId
    const backUrl = window.location.href + `?billId=${billId}`
    Toast.loading('加载中...')
    const {data} = await alipayApi({billId, quit_url: backUrl})
    Toast.hide()
    if (data.code === 'SUCCESS') {
      if (data.data && data.data.length > 0 && data.data.indexOf('<form') !== -1) {
        this.props.history.goBack()
        // 支付宝支付：获取接口返回form表单直接提交
        const div = document.createElement('div');
        div.innerHTML = data.data;
        document.body.appendChild(div);
        document.forms[0].submit();
      } else if (data.data && data.data.length > 0) {
        Toast.info(data.data)
      } else {
        Toast.info('调用支付宝链接失败,请尝试重新支付~')
      }
    } else {
      Toast.info(data.msg)
    }
  }

  async fetchWechatPayInfo() {
    // 微信支付：从接口获取返回数据
    const billId = this.billId
    const backUrl = window.location.href + `?billId=${billId}`
    Toast.loading('加载中...')
    const {data} = await wechatPayApi({billId, quit_url: backUrl})
    Toast.hide()
    if (data.code === 'SUCCESS') {
      // const redirectUrl = '&redirect_url=' + encodeURIComponent(backUrl)
      if (data.data && data.data.length > 0 && data.data.indexOf('https') !== -1) {
        // window.location.replace(data.data + redirectUrl)
        window.location.replace(data.data)
      } else if (data.data && data.data.length > 0) {
        Toast.info(data.data)
      } else {
        Toast.info('调用微信支付链接失败,请尝试重新支付~')
      }
    } else {
      Toast.info(data.msg)
    }
  }

  async fetchPayResult() {
    const billId = this.billId
    Toast.loading('加载中...')
    const {data} = await billResultApi({billId})
    Toast.hide()
    if (data.code === 'SUCCESS') {
      // 账单已付款、账单支付中、账单不存在
      if (data.data === '账单已付款') {
        this.props.history.goBack()
      } else  {
        Toast.info(data.data)
      }
    } else {
      Toast.info(data.msg)
    }
  }

  payTypeChange(payCode: string) {
    this.setState({
      payCode: payCode
    })
  }

  confirmPay() {
    if (this.state.payCode === 'alipay') {
      this.fetchAliPayInfo()
    } else if (this.state.payCode === 'wechat') {
      console.log('wechat')
      this.fetchWechatPayInfo()
    }
  }

  payWayListComponent() {
    const PayWayList = [{iconUrl: '/public/assets/img/bill_alipay.png', name: '支付宝', code: 'alipay'}, {iconUrl: '/public/assets/img/bill_wechat.png', name: '微信支付', code: 'wechat'}]
    let list: any = []
    PayWayList.forEach((ele: any) => {
      list.push(<Item
        style={{height: '60px'}}
        thumb={ele.iconUrl}
        key={ele.code}
        extra={this.checkBox(ele.code)}
        onClick={() => this.payTypeChange(ele.code)}
      >{ele.name}</Item>)
    })
    return list
  }

  checkBox(payCode: string) {
    return (
      <Radio style={{width: '24px', height: '24px'}} checked={this.state.payCode === payCode} onChange={e => console.log('checkbox', e)}></Radio>
    )
  }

  render() {
    
    return (
      <div className="pay-bill">
        <div className="top-brief">
          <span style={{fontSize: '14px', fontWeight: "bold", padding: '10px 0'}}>￥<span style={{fontSize: '20px', fontWeight: "bold"}}>{this.state.money}</span></span>
          <span style={{fontSize: '12px', color: '#888888'}}>{this.state.number}{this.state.subject_name}</span>
        </div>
        <List>
          {this.payWayListComponent()}
        </List>
        <div className="bottom-btn">
          <Button  type="warning" disabled={this.state.payCode.length === 0} onClick={this.confirmPay}>确认支付</Button>
        </div>
      </div>
    )
  }
}